import { DIRECTION_VECTOR_TOLERANCE } from '../Direction2D';
import { Line2Struct, Vec2Struct } from './types';

/**
 * Computes the intersection of two lines. Assumes both `a.direction` and `b.direction` are unit vectors.
 *
 * Returns `true` if the lines intersect (non-parallel), `false` if parallel.
 *
 * Only intended for use in performance-critical code where you need to avoid heap allocations.
 */
export function intersectLines(a: Line2Struct, b: Line2Struct, result: Vec2Struct): boolean {
  const cross = a.direction.x * b.direction.y - a.direction.y * b.direction.x;
  if (Math.abs(cross) <= DIRECTION_VECTOR_TOLERANCE) return false;

  const dx = b.basePoint.x - a.basePoint.x;
  const dy = b.basePoint.y - a.basePoint.y;
  const t = (dx * b.direction.y - dy * b.direction.x) / cross;

  result.x = a.basePoint.x + t * a.direction.x;
  result.y = a.basePoint.y + t * a.direction.y;
  return true;
}
